import { render, staticRenderFns } from "./EducationalSetting.vue?vue&type=template&id=48419fe5&scoped=true&"
import script from "./EducationalSetting.vue?vue&type=script&lang=js&"
export * from "./EducationalSetting.vue?vue&type=script&lang=js&"
import style0 from "./EducationalSetting.vue?vue&type=style&index=0&id=48419fe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48419fe5",
  null
  
)

export default component.exports